import ContentsTypes from "@dafrontcms/core/lib/cms/shared/enums/contentsTypes";
import ContentsCustomTypes from "@project/enums/contentsCustomTypes.enum";
import dayjs from "dayjs";
import ArticleCardListPreview from "../components/ArticleCardList/ArticledCardListPreview";
export const ArticleCardListItem = {
    label: "Bloc article",
    key: "items",
    type: ContentsCustomTypes.ARTICLE_CARD_LIST_ITEM,
    children: [
        {
            label: "Image",
            key: "image",
            type: ContentsTypes.IMAGE,
            value: "",
        },
        {
            label: "Titre",
            key: "title",
            type: ContentsTypes.INPUT,
            value: "",
        },
        {
            label: "Date",
            key: "date",
            type: ContentsTypes.INPUT,
            value: dayjs(Date.now()).format("D MMMM YYYY"),
        },
        {
            label: "Lien",
            key: "link",
            type: ContentsTypes.LINK,
            value: "",
        },
    ],
};
export const ArticleCardList = {
    label: "Liste d'articles",
    type: ContentsCustomTypes.ARTICLE_CARD_LIST,
    Preview: ArticleCardListPreview,
    icon: "address-card",
    editionModal: true,
    editionModalPosition: "top",
    children: [
        {
            label: "Nombre d'articles à afficher",
            key: "numberArticles",
            type: ContentsTypes.INPUT_NUMBER,
            value: "3",
        },
        {
            label: "Page parente des articles",
            key: "pageParent",
            type: ContentsTypes.PAGE,
            value: "",
        },
        {
            label: "Lien",
            key: "link",
            type: ContentsTypes.LINK,
            value: "",
        },
    ],
};
